import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  margin-bottom: 24px;
`

export const Content = styled.div`
  margin-left: 100px;
  padding-top: 0;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`
